import { render, staticRenderFns } from "./BankParameters.vue?vue&type=template&id=a52682ac"
import script from "./BankParameters.vue?vue&type=script&lang=js"
export * from "./BankParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports